import { render, staticRenderFns } from "./InstitutionWorkplaceCnpj.vue?vue&type=template&id=31d735dc&"
import script from "./InstitutionWorkplaceCnpj.vue?vue&type=script&lang=js&"
export * from "./InstitutionWorkplaceCnpj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports